import type { SVGProps } from 'react';

export function UnitedKingdomFlag(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 36 24"
      preserveAspectRatio="none"
      aria-hidden
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="36" height="24" fill="#012169" />
      <path d="M0 0L36 24M36 0L0 24" stroke="#ffffff" strokeWidth="5" />
      <path d="M0 0L36 24M36 0L0 24" stroke="#C8102E" strokeWidth="2" />
      <path d="M18 0V24M0 12H36" stroke="#ffffff" strokeWidth="8" />
      <path d="M18 0V24M0 12H36" stroke="#C8102E" strokeWidth="5" />
    </svg>
  );
}
